var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCurtir01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-like-2",
    d: "M27.3,34H4c-1.9,0-3.5-1.5-3.5-3.4V15.5c0-1.9,1.6-3.4,3.5-3.4h4.4l8.2-9.5C17,2.2,17.5,2,18,2h2.8 c1.1,0,2.2,0.5,2.8,1.4c0.7,0.9,0.8,2,0.5,3l-2,5.7H32c1.9,0,3.5,1.5,3.5,3.4v3.4c0,0.2,0,0.4-0.1,0.6l-4.8,12.4 C30,33.1,28.7,34,27.3,34z M18.8,5.4l-7.8,9v16.2h16.3L32,18.5v-3.1H19.7c-0.6,0-1.1-0.3-1.4-0.7c-0.3-0.4-0.4-1-0.2-1.5l2.7-7.9 L18.8,5.4z M4,15.5v15.2h3.5V15.5H4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCurtir01);
export default __webpack_public_path__ + "static/media/ico-curtir-01.20adc166971ce0d5e7798fc571bdb0b9.svg";
export { ForwardRef as ReactComponent };